import { create } from 'zustand';
import type { GuideIndexEntry, GuideDocument } from '../types/guide';

interface GuideState {
    // Index
    index: GuideIndexEntry[];
    indexLoading: boolean;
    indexError: string | null;

    // Active guide
    activeGuideId: string | null;
    activeGuide: GuideDocument | null;
    guideLoading: boolean;
    guideError: string | null;

    // Sidebar
    sidebarOpen: boolean;

    // Theme
    themeMode: 'light' | 'dark';

    // Actions
    setIndex: (index: GuideIndexEntry[]) => void;
    setIndexLoading: (loading: boolean) => void;
    setIndexError: (error: string | null) => void;

    setActiveGuideId: (id: string | null) => void;
    setActiveGuide: (guide: GuideDocument | null) => void;
    setGuideLoading: (loading: boolean) => void;
    setGuideError: (error: string | null) => void;

    toggleSidebar: () => void;
    setSidebarOpen: (open: boolean) => void;

    toggleTheme: () => void;
}

const useGuideStore = create<GuideState>((set) => ({
    // Index
    index: [],
    indexLoading: false,
    indexError: null,

    // Active guide
    activeGuideId: null,
    activeGuide: null,
    guideLoading: false,
    guideError: null,

    // Sidebar
    sidebarOpen: true,

    // Theme
    themeMode: 'light',

    // Actions

    setIndex: (index) => set({ index }),
    setIndexLoading: (indexLoading) => set({ indexLoading }),
    setIndexError: (indexError) => set({ indexError }),

    setActiveGuideId: (activeGuideId) => set({ activeGuideId }),
    setActiveGuide: (activeGuide) => set({ activeGuide }),
    setGuideLoading: (guideLoading) => set({ guideLoading }),
    setGuideError: (guideError) => set({ guideError }),

    toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),
    setSidebarOpen: (sidebarOpen) => set({ sidebarOpen }),

    toggleTheme: () => set((state) => ({ themeMode: state.themeMode === 'light' ? 'dark' : 'light' })),
}));

export default useGuideStore;